// GENERATED by scripts/build-virginia-place-outlines.mjs from US Census Bureau files. Do not edit by hand.
// Source: U.S. Census Bureau, 2025 Cartographic Boundary Files (Places, Virginia) and 2020 Cartographic
// Boundary Files (ZIP Code Tabulation Areas), 1:500,000. See VIRGINIA-PLACE-OUTLINES-SOURCE.md beside this file.
// Refresh: node scripts/build-virginia-place-outlines.mjs
/** The year of the Census boundary file the city, town and community outlines were built from. */
export const VIRGINIA_PLACE_OUTLINES_PLACES_YEAR = 2025;
/** The year of the Census boundary file the ZIP code area outlines were built from. */
export const VIRGINIA_PLACE_OUTLINES_ZCTA_YEAR = 2020;
/** How far the thinning was allowed to move a line, in metres. */
export const VIRGINIA_PLACE_OUTLINES_TOLERANCE_METRES = 50;
/** The side of one square of the map, in tenths of a degree. */
export const VIRGINIA_PLACE_OUTLINES_SQUARE_TENTHS = 5;
/** Listed places the Census boundary files have no outline for, by our place code. The map shows these as a pin. */
export const VIRGINIA_PLACE_CODES_WITHOUT_OUTLINE = [];
/**
 * One loader for each square of the map that holds an outline. Each `import()` becomes its own file in the web
 * build, fetched from our own origin the first time an outline in that square is asked for.
 */
export const VIRGINIA_PLACE_OUTLINE_SQUARES = {
    n365w760: () => import('./virginia-place-outlines/n365w760.generated.js'),
    n365w765: () => import('./virginia-place-outlines/n365w765.generated.js'),
    n365w770: () => import('./virginia-place-outlines/n365w770.generated.js'),
    n365w775: () => import('./virginia-place-outlines/n365w775.generated.js'),
    n365w780: () => import('./virginia-place-outlines/n365w780.generated.js'),
    n365w785: () => import('./virginia-place-outlines/n365w785.generated.js'),
    n365w790: () => import('./virginia-place-outlines/n365w790.generated.js'),
    n365w795: () => import('./virginia-place-outlines/n365w795.generated.js'),
    n365w800: () => import('./virginia-place-outlines/n365w800.generated.js'),
    n365w805: () => import('./virginia-place-outlines/n365w805.generated.js'),
    n365w810: () => import('./virginia-place-outlines/n365w810.generated.js'),
    n365w815: () => import('./virginia-place-outlines/n365w815.generated.js'),
    n365w820: () => import('./virginia-place-outlines/n365w820.generated.js'),
    n365w825: () => import('./virginia-place-outlines/n365w825.generated.js'),
    n365w830: () => import('./virginia-place-outlines/n365w830.generated.js'),
    n365w835: () => import('./virginia-place-outlines/n365w835.generated.js'),
    n365w840: () => import('./virginia-place-outlines/n365w840.generated.js'),
    n370w760: () => import('./virginia-place-outlines/n370w760.generated.js'),
    n370w765: () => import('./virginia-place-outlines/n370w765.generated.js'),
    n370w770: () => import('./virginia-place-outlines/n370w770.generated.js'),
    n370w775: () => import('./virginia-place-outlines/n370w775.generated.js'),
    n370w780: () => import('./virginia-place-outlines/n370w780.generated.js'),
    n370w785: () => import('./virginia-place-outlines/n370w785.generated.js'),
    n370w790: () => import('./virginia-place-outlines/n370w790.generated.js'),
    n370w795: () => import('./virginia-place-outlines/n370w795.generated.js'),
    n370w800: () => import('./virginia-place-outlines/n370w800.generated.js'),
    n370w805: () => import('./virginia-place-outlines/n370w805.generated.js'),
    n370w810: () => import('./virginia-place-outlines/n370w810.generated.js'),
    n370w815: () => import('./virginia-place-outlines/n370w815.generated.js'),
    n370w820: () => import('./virginia-place-outlines/n370w820.generated.js'),
    n370w825: () => import('./virginia-place-outlines/n370w825.generated.js'),
    n370w830: () => import('./virginia-place-outlines/n370w830.generated.js'),
    n375w755: () => import('./virginia-place-outlines/n375w755.generated.js'),
    n375w760: () => import('./virginia-place-outlines/n375w760.generated.js'),
    n375w765: () => import('./virginia-place-outlines/n375w765.generated.js'),
    n375w770: () => import('./virginia-place-outlines/n375w770.generated.js'),
    n375w775: () => import('./virginia-place-outlines/n375w775.generated.js'),
    n375w780: () => import('./virginia-place-outlines/n375w780.generated.js'),
    n375w785: () => import('./virginia-place-outlines/n375w785.generated.js'),
    n375w790: () => import('./virginia-place-outlines/n375w790.generated.js'),
    n375w795: () => import('./virginia-place-outlines/n375w795.generated.js'),
    n375w800: () => import('./virginia-place-outlines/n375w800.generated.js'),
    n375w805: () => import('./virginia-place-outlines/n375w805.generated.js'),
    n380w755: () => import('./virginia-place-outlines/n380w755.generated.js'),
    n380w770: () => import('./virginia-place-outlines/n380w770.generated.js'),
    n380w775: () => import('./virginia-place-outlines/n380w775.generated.js'),
    n380w780: () => import('./virginia-place-outlines/n380w780.generated.js'),
    n380w785: () => import('./virginia-place-outlines/n380w785.generated.js'),
    n380w790: () => import('./virginia-place-outlines/n380w790.generated.js'),
    n380w795: () => import('./virginia-place-outlines/n380w795.generated.js'),
    n380w800: () => import('./virginia-place-outlines/n380w800.generated.js'),
    n385w775: () => import('./virginia-place-outlines/n385w775.generated.js'),
    n385w780: () => import('./virginia-place-outlines/n385w780.generated.js'),
    n385w785: () => import('./virginia-place-outlines/n385w785.generated.js'),
    n385w790: () => import('./virginia-place-outlines/n385w790.generated.js'),
    n385w795: () => import('./virginia-place-outlines/n385w795.generated.js'),
    n385w800: () => import('./virginia-place-outlines/n385w800.generated.js'),
    n390w775: () => import('./virginia-place-outlines/n390w775.generated.js'),
    n390w780: () => import('./virginia-place-outlines/n390w780.generated.js'),
    n390w785: () => import('./virginia-place-outlines/n390w785.generated.js'),
};
//# sourceMappingURL=virginia-place-outlines.generated.js.map